import { render } from "./JudgeDetailPage.vue?vue&type=template&id=35d1b853&ts=true"
import script from "./JudgeDetailPage.vue?vue&type=script&lang=ts"
export * from "./JudgeDetailPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__